<template>
    <div v-if="state.loading" style="text-align: center;">
        <img src="../assets/img/ajldr.gif" style="width: 100px"/>
    </div>
    <div v-else style="padding: 0 20px;">
        <div>
            <p class="oname">Welcome to {{system.oname}}</p>
        </div>
        <div class="box v-flex" style="flex-wrap:wrap">
            <Dashbox v-for="(box, idx) in box" :key="idx" :box="box" style="padding-left: 0;"/>
        </div>
        <div class="graphlist v-flex gap-3" style="display:none !important">
            <div class="graphbox col-lg-4 col-md-4 .col-sm-12 col-xs-12">
                <h3 class="graphtitle">
                    Tasks Summary
                </h3>
                <p class="graphsubtitle">
                    Task Progress This Week at a Glance
                </p>
                <GraphComponent :type="'line'" :data="chartData" :options="chartOptions" />
            </div>
            <div class="graphbox col-lg-4 col-md-4 .col-sm-12 col-xs-12">
                <h3 class="graphtitle">
                    Complaint Summary
                </h3>
                <p class="graphsubtitle">
                    Customer complaint for this month
                </p>
                <GraphComponent :type="'line'" :data="chartData" :options="chartOptions" />
            </div>
            <div class="graphbox col-lg-4 col-md-4 .col-sm-12 col-xs-12">
                <h3 class="graphtitle">
                    Tasks Summary
                </h3>
                <p class="graphsubtitle">
                    Task Progress This Week at a Glance
                </p>
                <GraphComponent :type="'line'" :data="chartData" :options="chartOptions" />
            </div>
        </div>
        <div class="clnd col-lg-9 col-md-9">
            <FullCalendar
                v-model="selectedDate"
                :events="calendarEvents"
                @event-click="handleEventClick"
            />
        </div>
    </div>

    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <FormView :columns="1"
            :fields="viewFields" :errors="state.errors"
            :loading="state.modalLoading" />
    </ModalView> 
</template>
<script>
import icons from '@/assets/js/icons.js';
import { defineComponent, ref,onMounted, reactive, computed} from 'vue';
import GraphComponent from '@/components/GraphView.vue';
import Dashbox from '@/components/DashBox.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import FullCalendar from '@/components/FullCalendar.vue';
import ModalView from '@/components/ModalView.vue';
import FormView from '@/components/FormView.vue';

export default defineComponent({
name: 'DepartmentsView',
components: { GraphComponent,Dashbox, FullCalendar,ModalView,FormView },
setup(){
    const svgIcons = ref(icons);
    const store= useStore();
    const router = useRouter();
    const system = computed(() => store.state.System.system);
    const state=reactive({loading:false, modalLoading:false,ViewModal:false, errors:[]})
    const box=ref([]);
    const viewFields=ref([]);
    var chartData= {
        labels: ['Jan', 'Feb', 'Mar', 'Apr'],
        datasets: [
            {
            label: 'Sales',
            data: [30, 40, 50, 60],
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
            },
        ],
    };
    var chartOptions={
        responsive: true,
    }
    const selectedDate = ref(null);

    function setErrors(res){
        var errors=[];
        Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
            er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
        });
        state.errors=errors;
    }

    const calendarEvents = ref([]);

    const handleEventClick = (event) => {
        if(event.id == "tasks"){
            router.push({ name: 'mytasks'});
            return;
        }
        state.ViewModal=true;
        state.modalLoading=true;
        call({
            url:urls.schedule,
            data:{getSchedule:event.id},
            success:(res)=>{
            state.modalLoading=false;
            if(res.status){
                viewFields.value.length=0;
                var d=res.msg.data;
                var sdate=d.sdate.split('|'),
                sd=sdate[0]+" by "+sdate[1],
                date=sd;
                if(d.edate != ""){
                    var edate=d.edate.split('|'),
                    ed=edate[0]+" by "+edate[1];
                    date="From "+sd+" to "+ ed;
                }
                viewFields.value=[
                { name: "Schedule Details", number: "1",data: 
                    [{ name: 'title', label: 'Title',
                    value: d.title  },
                    { name: 'desc', label: 'Description',
                    value: d.desc },
                    {name:"type", label:"Type", value:d.type},
                    { name: 'start', label: 'Date',
                    value: date  },
                    {name:"privacy", label:"Visibility",
                        value:d.privacy
                    },
                    {name:"assignees", label:"Assigned to",
                        value:d.ass_n
                    }
                    ]
                }
                ]
            }else{
                setErrors(res)
            }
            }
        })
    }
    

    onMounted(() => {
        state.loading=true;
      call({
        url:urls.dashboard,
        data:{getUserDash:""},
        success:(res)=>{
          state.loading=false
          if(res.status){
            var d=res.msg;
            box.value=[];
            Object.keys(d.box).forEach(k => {
                box.value.push(d.box[k])
            })
            calendarEvents.value=[];
            Object.keys(d.cal).forEach(k => {
                calendarEvents.value.push(d.cal[k])
            })
          }else{
            alert(res.msg);
          }
        }
      })
    });
    
  return{icons: svgIcons.value,chartOptions,chartData, box,state,system,selectedDate,
      calendarEvents,viewFields,
      handleEventClick}
}
})

</script>   

<style scoped>
.graphlist .graphbox{background: var(--white-color); padding: 20px;
    border-radius: 20px; margin: 20px 0; 
    box-shadow: 0 2px 6px 0 rgb(218 218 253 / 65%), 0 2px 6px 0 rgb(206 206 238 / 54%);}
body.dark-mode .graphbox{box-shadow: none;}
.graphbox h3{font-size: 1rem; font-weight: 600; margin: 0; color: var(--black); 
    line-height: 1.625;}
.graphbox p{color: var(--light-text-color); font-size: 14px; margin-bottom: 1.2rem;}
.oname{color: var(--black); font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 16px;}
</style>